import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import saveAs from 'file-saver';
import { tap } from 'rxjs/operators';

export interface DownloadOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType: 'arraybuffer';
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ShimanoFileDownloadService {
  constructor(protected http: HttpClient) {}

  downloadCsv(requestMethod: string, url: string, options: DownloadOptions, fileNameStr: string, body?: any) {
    const request = requestMethod === 'GET' ? this.http.get(url, options) : this.http.post(url, body, options);

    return request.pipe(
      tap((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const fileName = `${fileNameStr}.csv`;
        const url = window.URL.createObjectURL(blob);
        const urlsafari = (window as any).webkitURL.createObjectURL(blob);
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') > -1 || ua.indexOf('chrome') > -1 || ua.indexOf('firefox') > -1) {
          if (ua.indexOf('chrome') > -1 || ua.indexOf('firefox') > -1) {
            saveAs(url, fileName);
          } else {
            if (this.checkVersion() >= 13) {
              const chrome = ua.indexOf('chrome') > -1 && ua.indexOf('safari') > -1;

              if (!chrome) {
                const reader = new FileReader();
                reader.onloadend = () => {
                  this.deviceDownloader(reader.result.toString(), fileName);
                };
                reader.readAsDataURL(blob);
              } else {
                saveAs(urlsafari, fileName);
              }
            } else {
              const chrome = ua.indexOf('chrome') > -1 && ua.indexOf('safari') > -1;

              if (!chrome) {
                const reader = new FileReader();
                reader.onloadend = () => {
                  this.deviceDownloader(reader.result.toString(), fileName);
                };
                reader.readAsDataURL(blob);
              } else {
                this.deviceDownloader(urlsafari, fileName);
              }
            }
          }
        }
      })
    );
  }

  deviceDownloader(url: string, fileName: string) {
    const href = document.createElement('a');
    href.href = url;
    href.target = '_self';
    href.style.display = 'none';
    href.download = fileName;
    document.body.appendChild(href);
    href.click();
    href.parentNode.removeChild(href);
  }

  checkVersion(): any {
    const agent = window.navigator.userAgent;
    const start = agent.indexOf('OS');
    if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
      return agent.substr(start + 3, 3).replace('_', '.');
    }
    return 0;
  }
}
